import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';

const InputContainer = ({ errors, label, required, name, help, children }) => {
  return (
    <div
      className={classNames('form-group m-form__group', {
        'has-danger': errors[name],
      })}
    >
      <label htmlFor="amount">
        <Trans>{label}</Trans> {!!required && '*'}
      </label>

      {children}

      {help && (
        <span className="m-form__help">
          <Trans>{help}</Trans>
        </span>
      )}

      {errors[name] && (
        <div className="form-control-feedback">
          <Trans>{errors[name].message}</Trans>
        </div>
      )}
    </div>
  );
};

InputContainer.propTypes = {
  errors: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  help: PropTypes.string,
  children: PropTypes.element.isRequired,
};

export default InputContainer;
